<script setup lang="ts">
definePageMeta({
  track_catalog_items: true,
  hide_quick_search: true
})
</script>

<template>
  <CorePage page="search-vehicles" :blocks="['CatalogPromoBanner', 'VehicleCatalog']"/>
</template>
